import type { EditableAction } from '../components/ConversationActionsSection';
import type { GenesysDivision } from '../services/genesys-api';

/** Sample action for the dev preview of Conversation Actions. Not saved. */
export function previewAction(): EditableAction {
  return {
    key: 'preview-order',
    actionId: 'preview-order',
    type: 'CREATE_ORDER',
    label: 'Create order',
    enabled: true,
    webhookUrl: 'https://crm.example.com/hooks/orders',
    authType: 'bearer',
    secret: '',
    hasSecret: true,
    headerName: '',
    timeoutSeconds: 10,
    divisionIds: [],
    divisionsText: '',
    businessContext: 'Wholesale dairy supplier to grocery stores.',
    customFields: [],
    replyLanguage: 'en',
    infoFields: [],
    catalogSummary: {
      products: 1280,
      imported: 1280,
      skipped: 2,
      duplicates: 1,
      updatedAt: '2026-03-15T15:04:00.000Z',
    },
    webhookTestedAt: '2026-03-15T15:04:00.000Z',
    version: 1,
  };
}

export function previewDivisions(): GenesysDivision[] {
  return [
    { id: '3f2b8c1e-5d4a-4b6c-9e7f-0a1b2c3d4e5f', name: 'Sales' },
    { id: '8a1c0d2e-1111-4222-8333-444455556666', name: 'Support' },
  ];
}

export const PREVIEW_ALLOWED_TYPES = ['CREATE_ORDER', 'CREATE_RETURN', 'SEND_FILES', 'CONVERSATION_INFO'];
export const PREVIEW_BILLED_TYPES = ['CREATE_ORDER', 'CREATE_RETURN'];
